import { updateFeeds } from '@/mocks/principles';

export default function UpdatesSection() {
  return (
    <section id="updates" className="scroll-mt-16 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
              <i className="ri-refresh-line text-sm"></i> 更新动态
            </span>
            <h2 className="heading-font mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">最近更新了什么</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              我们持续对事件时间线进行复核与补全。以下是最新的修订记录，所有改动均可追溯、可监督。
            </p>
            <div className="mt-8 space-y-4">
              {updateFeeds.map((u) => (
                <div key={u.id} className="flex items-start gap-4 rounded-lg bg-background-100 p-4">
                  <span className="flex h-10 w-10 shrink-0 flex-col items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className="ri-edit-2-line"></i>
                  </span>
                  <div className="min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="heading-font text-xs font-bold text-foreground-700">{u.date} {u.time}</span>
                      <span className="rounded-full bg-primary-100 px-2 py-0.5 text-[11px] font-semibold text-primary-700">{u.type}</span>
                    </div>
                    <p className="mt-1.5 text-sm font-medium text-foreground-900">{u.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div id="about" className="scroll-mt-16 flex flex-col justify-center rounded-lg bg-background-100 p-6 md:p-8">
            <h3 className="heading-font text-2xl font-bold text-foreground-950">关于海角吃瓜</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              海角吃瓜是一个专注事件始末整理与真相追踪的独立资讯平台。我们相信，真正有价值的"吃瓜"不是凑热闹，
              而是在信息泛滥时帮你把事情看明白。从线索的初次浮现，到各方回应的分歧，再到权威信息的澄清，
              我们用一根清晰的时间线把前因后果串联起来，并如实标注每一条信息的可信度。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              我们始终坚持：只整理公开信息、不替任何单方背书、发现错误及时勘误、热度过后持续维护。愿我们整理的每一份时间线，
              都能让你在海量信息中少走弯路、更快接近事件真相。
            </p>
            <div className="mt-6 grid grid-cols-3 gap-3 border-t border-background-200 pt-6 text-center">
              {[
                ['独立立场', '不站队'],
                ['持续维护', '不烂尾'],
                ['如实标注', '不夸大'],
              ].map(([a, b]) => (
                <div key={a} className="rounded-md bg-background-50 px-2 py-3">
                  <div className="heading-font text-sm font-bold text-primary-600">{a}</div>
                  <div className="mt-1 text-xs text-foreground-500">{b}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}